import React from "react";
import "./Testimonials.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import testimonialsObjectList from "../../objects/Testimonials";
import MobileTesti from "./mtestimonials/MobileTesti";
import { useFeedbackGetQuery } from "../../slice/authApiSlice";
import { generatePublicUrl } from "../../constants";
import profileImg from "../../assets/images/hire_profile_img.jpg";

const Testimonials = () => {
  const {
    data: feedbackGet,
    isLoading: isLoadingjobDet,
    error: jobError,
  } = useFeedbackGetQuery();

  const fallbackData = testimonialsObjectList;
  const isApiData = feedbackGet && feedbackGet.length > 0;
  const testimonialsData = isApiData ? feedbackGet : fallbackData;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const showError = jobError && fallbackData.length === 0;

  return (
    <div className="testimonials_section">
      {isLoadingjobDet ? (
        <p>Loading testimonials...</p>
      ) : showError ? (
        <p>Error loading testimonials. Please try again later.</p>
      ) : null}

      <div className="testimonials_container">
        <h1 className="section_heading">Testimonials</h1>

        {testimonialsData.length > 0 ? (
          <div className="testimonials_card_container">
            <Slider {...settings} className="testimonial_slider">
              {testimonialsData.map((obj, indx) => (
                <div className="testimonials_card" key={indx}>
                  <div className="t_card_img_container">
                    {isApiData ? (
                      obj.user?.profilePictures?.length > 0 ? (
                        <img
                          src={generatePublicUrl(obj.user.profilePictures[0]?.img)}
                          alt="profile-img"
                        />
                      ) : (
                        <img src={profileImg} alt="profile-img" />
                      )
                    ) : (
                      <img src={obj.img} alt="profile-img" />
                    )}
                  </div>
                  <div className="t_card_description">
                    <p className="t_card_user_message">{obj.description}</p>
                    <div className="rating-adj">
                      <p className="t_card_user_designation">{obj.designation}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ) : (
          <p>No testimonials available.</p>
        )}
      </div>

      <div className="mt_container_section">
        <MobileTesti />
      </div>
    </div>
  );
};

export default Testimonials;




